module.exports = __webpack_public_path__ + "img/Frame-70.57aa9922.svg";